export enum SearchParamTypeEnum {
    SEARCH_CRITERIA = 'searchCriteria',
    FILTERS = 'filters',
}

export const SEARCH_PARAM_CATEGORIES = {
    [SearchParamTypeEnum.SEARCH_CRITERIA]: [
        'location',
        'checkInDate',
        'checkOutDate',
        'adultsCount',
        'childrenCount',
        'childrenAges',
        'guestCount',
        'geoId',
        'type',
    ],
    [SearchParamTypeEnum.FILTERS]: [
        'propertyType',
        'amenities',
        'rating',
        'priceFrom',
        'priceTo',
        'provision',
        'reservationFeatures',
    ],
};
